import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _includes from "lodash/includes";
import _xor from "lodash/xor";
import _find from "lodash/find";
import _get from "lodash/get";
import _each from "lodash/each";
import _uniqueid from "lodash/uniqueId";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import React, { Component } from 'react';
import classNames from 'classnames';
import { CheckboxOption } from '../Checkbox/CheckboxOption';
import { Type } from '../Type/Type';
import { DropdownTrigger } from './DropdownTrigger';
import { OPTION_PROPS } from './prop-types';
import styles from './Multiselect.module.less';
export var Multiselect = /*#__PURE__*/function (_Component) {
  _inherits(Multiselect, _Component);

  var _super = _createSuper(Multiselect);

  /*
    When wrapped in an InputGroup component this tells the InputGroup
    to use fieldset so that we won't have the child checkbox `<label>`'s wrapped
    in a parent label for the Multiselect. This causes odd behavior.
  */
  function Multiselect(props) {
    var _this;

    _classCallCheck(this, Multiselect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOptionChange", function (e) {
      var selectedValue = _get(e, 'target.value'); // _.xor() is basically _.toggle()


      var value = _xor(_this.props.value, [selectedValue]);

      _this.props.onChange({
        target: {
          value: value
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideDropdownClick", function (e) {
      var menuNode = _this.menu.current;
      var buttonNode = _this.button.current;

      if (menuNode.contains(e.target) || buttonNode.contains(e.target)) {
        return;
      }

      _this.toggleOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "handleEscape", function (e) {
      var ESCAPE_KEY = 27;

      if (e.keyCode === ESCAPE_KEY && _this.state.isOpen) {
        _this.toggleOpen();
      }
    });

    var id = props.id,
        name = props.name;
    _this.state = {
      isOpen: false
    };
    _this.button = /*#__PURE__*/React.createRef();
    _this.menu = /*#__PURE__*/React.createRef(); // ensure the instance has an id and name to prevent unexpected option
    // selection behavior and to enhance accessibility

    _this.id = id || _uniqueid();
    _this.name = name || _uniqueid();
    return _this;
  }

  _createClass(Multiselect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (prevState.isOpen !== this.state.isOpen) {
        this.configureComponentListeners(this.state.isOpen);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.configureComponentListeners(false);
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value, options) {
      var _this2 = this;

      if (options && options.length > 0 && options[0].options) {
        var label = '';

        _each(options, function (groupOption) {
          label = label === '' ? _this2.getLabelForValue(value, groupOption.options) : label;
        });

        return label;
      }

      return _get(_find(options, function (option) {
        return option.value === value;
      }), 'label', '');
    }
  }, {
    key: "getSelectionText",
    value: function getSelectionText(value, options) {
      switch (value.length) {
        case 0:
          return 'Select one or multiple';

        case 1:
          return this.getLabelForValue(value[0], options);

        default:
          return "".concat(value.length, " selected");
      }
    }
  }, {
    key: "configureComponentListeners",
    value: function configureComponentListeners(isOpen) {
      if (isOpen) {
        // listen for escape character when menu is open
        document.addEventListener('keydown', this.handleEscape); // listen for click outside to close the menu when appropriate

        document.addEventListener('click', this.handleOutsideDropdownClick);
      } else {
        document.removeEventListener('keydown', this.handleEscape);
        document.removeEventListener('click', this.handleOutsideDropdownClick);
      }
    }
  }, {
    key: "renderSelectLabel",
    value: function renderSelectLabel() {
      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value,
          disabled = _this$props.disabled;
      var color = Array.isArray(value) && value.length > 0 && !disabled ? 'neutral-darkest' : 'neutral-darker';
      return /*#__PURE__*/React.createElement(Type, {
        color: color
      }, this.getSelectionText(value, options));
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var name = this.name,
          id = this.id;
      var label = option.label,
          value = option.value,
          disabled = option.disabled;
      return /*#__PURE__*/React.createElement("li", {
        key: "option__".concat(label, "__").concat(value)
      }, /*#__PURE__*/React.createElement(CheckboxOption, {
        value: value,
        label: label,
        name: name,
        id: "".concat(name, "--").concat(option.label, "-").concat(option.value, "--").concat(id),
        "aria-controls": id,
        className: styles.checkbox,
        disabled: disabled,
        onChange: this.handleOptionChange,
        checked: _includes(this.props.value, value)
      }));
    }
  }, {
    key: "renderGroupOption",
    value: function renderGroupOption(groupOption) {
      var _this3 = this;

      var items = groupOption.options.map(function (o) {
        return _this3.renderOption(o);
      });
      var title = /*#__PURE__*/React.createElement("li", {
        key: "title__".concat(groupOption.title)
      }, /*#__PURE__*/React.createElement(Type, {
        bold: true,
        className: styles.groupLabel
      }, groupOption.title));
      items.unshift(title);
      return items;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this4 = this,
          _classNames;

      var options = this.props.options;
      var items = options.map(function (option) {
        if (option.options) {
          return _this4.renderGroupOption(option);
        }

        return _this4.renderOption(option);
      });
      return /*#__PURE__*/React.createElement("div", {
        ref: this.menu,
        className: classNames((_classNames = {}, _defineProperty(_classNames, styles.openOptions, this.state.isOpen), _defineProperty(_classNames, styles.openOptionsError, this.props.error && this.state.isOpen), _classNames), styles.optionContainer)
      }, this.state.isOpen && /*#__PURE__*/React.createElement("ul", {
        className: styles.list
      }, items));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          innerRef = _this$props2.innerRef,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus;
      var containerClasses = classNames(className, styles.container, _defineProperty({}, styles.fullWidth, fullWidth));
      return /*#__PURE__*/React.createElement("div", {
        className: containerClasses,
        ref: innerRef
      }, /*#__PURE__*/React.createElement(DropdownTrigger, {
        mode: "button",
        ref: this.button,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        onClick: this.toggleOpen,
        onFocus: onFocus,
        onBlur: onBlur
      }, this.renderSelectLabel()), this.renderOptions());
    }
  }]);

  return Multiselect;
}(Component);

_defineProperty(Multiselect, "displayName", 'Multiselect');

_defineProperty(Multiselect, "defaultProps", {
  className: null,
  disabled: false,
  error: false,
  fullWidth: false,
  id: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
});

_defineProperty(Multiselect, "shouldUseFieldset", true);

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  Multiselect.propTypes = {
    /* custom className for multiselect */
    className: PropTypes.string,

    /* controls whether the multiselect is disabled */
    disabled: PropTypes.bool,

    /* controls the visual error state */
    error: PropTypes.bool,

    /* id of the multiselect */
    id: PropTypes.string,

    /* controls if multiselect should be full width */
    fullWidth: PropTypes.bool,

    /* Used as a name attribute for the underlying <CheckboxOption />. */
    name: PropTypes.string,

    /* callback for onBlur */
    onBlur: PropTypes.func,

    /* callback for onChange */
    onChange: PropTypes.func,

    /* callback for onFocus */
    onFocus: PropTypes.func,

    /* options for user to select */
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(OPTION_PROPS)), PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      options: OPTION_PROPS
    }))]).isRequired,

    /* currently selected value */
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired
  };
}